/** @jsxImportSource @emotion/react */
import React, { Component, useState } from 'react'
import { jsx, css } from '@emotion/react'
import { default_theme as theme } from '../../emotion/theme'
import { Button } from 'react-bootstrap'
import { BaseButton } from './BaseButton'

export const WhiteLinkButton = ({ onClick, children, ...props }) => {
    return (
        <BaseButton variant="link" extra_css={style} auto_disable="false" onClick={onClick} {...props}>
          {children}
        </BaseButton>
    )
}

const style = css`
padding-left: 0px;
color: ${theme.colors.white};
font-weight: 500;
margin-top: 0px;
padding-top: 0px;
padding-bottom: 0px;

&:hover {
  color: ${theme.colors.white};
  text-decoration: none;
}
`
